<div class="container-fluid widget-wrapper" #widgetHeader>
  <div class="row widget-header" [ngClass]="{ sticky: isTop }">
    <div class="col-lg-12">
      <h2>
        <span>Invalid Traffic (IVT)</span><span class="app-title">&nbsp;{{ appName | appPrefix }}</span>
        <a class="btn btn-link p-0" data-toggle="tooltip"
          title="Apps are measured according to the industry standard classifications of invalid traffic.">
          <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon" />
        </a>
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body">
    <div class="col-lg-12 px-0">
      <app-ctv-ivt [data]="data" [isFollowing]="isFollowing" [isFreemium]="isFreemium"></app-ctv-ivt>
    </div>
  </div>
</div>
